import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { IClassificacaoMercadologica, StringUtilsService } from '@vip/core';

@Component({
  selector: 'vip-dropdown-departamentos',
  templateUrl: './dropdown-departamentos.component.html',
  styleUrls: ['./dropdown-departamentos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DropdownDepartamentosComponent {
  @Input() items: IClassificacaoMercadologica[] = [];

  @Output() itemClick = new EventEmitter<IClassificacaoMercadologica>();

  @ViewChild('submenu') submenuRef!: ElementRef<HTMLDivElement>;

  departamentoAberto?: IClassificacaoMercadologica;
  hasCategories = false;

  constructor(public stringUtilsService: StringUtilsService) {}

  buildUrl(dep: IClassificacaoMercadologica): string {
    const part = dep.link.startsWith('/') ? dep.link : '/' + dep.link;
    return '/departamentos' + part;
  }

  openSubmenu(dep: IClassificacaoMercadologica): void {
    this.departamentoAberto = undefined;

    if (dep.children) {
      this.departamentoAberto = dep;
      this.hasCategories = dep.children.some(
        (c) => c.children && c.children.length > 0,
      );
    }
  }

  closeSubmenu(): void {
    this.departamentoAberto = undefined;
  }

  openSubmenuAndFocus(dep: IClassificacaoMercadologica): void {
    this.openSubmenu(dep);

    const focusFn = () => {
      const el = this.submenuRef?.nativeElement as HTMLElement | undefined;
      if (el) {
        el.focus();
      }
    };

    if (typeof queueMicrotask === 'function') {
      queueMicrotask(focusFn);
      return;
    }

    setTimeout(focusFn, 0);
  }

}
